import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import createApi from './api'
import logout from './logout'
import initHistory from './history'
import createStore from './store'
import initTracking from './tracking'
import getEnvName from './env-util'

import App from './app'

export const handleError = (location) => (error) => {
  // eslint-disable-next-line
  console.error(`Unable to authenticate: ${error.message}`)

  logout(location)
}

export const runApp = (baseUrl) => (user) => {
  const history = initHistory()
  const env = getEnvName(window.location)
  const appInsights = initTracking(env, history)

  const api = createApi(baseUrl, user)

  const store = createStore({api, appInsights})

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  )
}



// WEBPACK FOOTER //
// ./src/start.js